// Atendimento que fecha sozinho (Bigens, 2026-10-22): leitura e gravação das
// duas seções novas das Automações da etapa. "Mudar de etapa sozinho"
// (message_transitions: para onde o contato vai, a partir desta etapa, quando
// ele escreve ou quando nós respondemos) e "Esta etapa encerra o atendimento"
// (closing: resumo da IA, tag de motivo de uma lista fixa e volta ao agente).
// Puro: a gaveta guarda o estado e chama daqui.

// Teto da lista de tags de motivo (o backend recusa acima disso).
export const MAX_TAGS_DE_MOTIVO = 30;

// Destinos possíveis de "Mudar de etapa sozinho": etapas do MESMO funil, menos
// a própria, na ordem das colunas (o backend recusa etapa de outro funil).
// Etapa sem funil (catálogo antigo) é do funil "".
export const etapasDoMesmoFunil = (allLabels, label) => {
  const funil = (label && label.pipeline_id) || '';
  return (Array.isArray(allLabels) ? allLabels : [])
    .filter((l) => l && l.id && l.id !== (label && label.id) && (l.pipeline_id || '') === funil)
    .sort((a, b) => (a.order || 0) - (b.order || 0));
};

// Estado inicial das duas seções a partir da etapa salva. Resumo e devolução
// ao agente vêm ligados por padrão, como no backend.
export const lerAtendimento = (cfg) => {
  const mt = (cfg && cfg.message_transitions) || {};
  const cl = (cfg && cfg.closing) || {};
  return {
    transitionOnInbound: mt.on_inbound || '',
    transitionOnOutbound: mt.on_outbound || '',
    closingEnabled: Boolean(cl.enabled),
    closingSummary: cl.summary !== false,
    closingReasonTagIds: Array.isArray(cl.reason_tag_ids) ? cl.reason_tag_ids.filter(Boolean) : [],
    closingReturnToAgent: cl.return_to_agent !== false,
  };
};

// A etapa de encerramento não muda quando nós respondemos: a própria mensagem
// de encerramento puxaria o contato de volta. A tela desabilita o seletor.
export const saidaBloqueada = (closingUi, closingEnabled) => Boolean(closingUi && closingEnabled);

// Campos do PUT da etapa. Seção sem a flag fica fora do payload (ausente = o
// backend não altera); etapa de encerramento grava a saída nula.
export const atendimentoParaSalvar = (estado, { transitionsUi, closingUi }) => {
  const out = {};
  if (transitionsUi) {
    out.message_transitions = {
      on_inbound: estado.transitionOnInbound || null,
      on_outbound: saidaBloqueada(closingUi, estado.closingEnabled)
        ? null
        : (estado.transitionOnOutbound || null),
    };
  }
  if (closingUi) {
    out.closing = {
      enabled: Boolean(estado.closingEnabled),
      summary: Boolean(estado.closingSummary),
      reason_tag_ids: estado.closingReasonTagIds || [],
      return_to_agent: Boolean(estado.closingReturnToAgent),
    };
  }
  return out;
};
